import React from 'react';
import PropTypes from 'prop-types';
import styles from './IgnoreModal.module.css';
import { TICKET_CONFIG } from './ticketConfig';

export const IgnoreModal = ({ 
  isOpen, 
  onClose, 
  onIgnore 
}) => {
  if (!isOpen) return null;

  const handleIgnore = (days) => {
    onIgnore(days);
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3 className={styles.title}>Ignore Ticket</h3>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className={styles.content}>
          <p className={styles.description}>
            How long would you like to ignore this ticket?
          </p>
          
          <div className={styles.options}>
            {TICKET_CONFIG.IGNORE_OPTIONS.map((option) => (
              <button 
                key={option.days}
                className={styles.optionButton}
                onClick={() => handleIgnore(option.days)}
              >
                <div className={styles.optionContent}>
                  <span className={styles.optionTitle}>{option.label}</span>
                  <span className={styles.optionSubtitle}>{option.subtitle}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
        
        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

IgnoreModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onIgnore: PropTypes.func.isRequired
};